( function() {
  if( 'cookieEnabled' in navigator ){ return; }

  document.cookie = "testcookie";
  if( document.cookie.indexOf( "testcookie" ) === -1 ) {
		console.error( 'Cookies Disabled.' );
	}
} )();
